import AuthUtils from '../../authentication/auth-utils';
import { NavbarItem } from './types';

export function getRouteRootPathname(pathname: string) {
  return pathname.split('/').slice(0, 2).join('/');
}

/**
 * The route a top nav item opens: for an item flagged openFirstChild, the first sub menu
 * item shown to the user (in the sub nav bar and allowed by their privileges); otherwise,
 * or when no sub menu item is available, the item's own route.
 */
export function getNavItemLandingRoute(navItem: NavbarItem, privileges: string[] = []): string {
  if (navItem.openFirstChild) {
    const firstChild = navItem.children?.find((child) => (
      child.isTopMenu && AuthUtils.hasPermissions(child.permissions, privileges)
    ));
    if (firstChild) return firstChild.route;
  }
  return navItem.route;
}
